var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('runnit-dynamic-field-label-row',{attrs:{"field":_vm.field,"label-styles":{ padding: '0' },"admin-only":_vm.adminOnly},scopedSlots:_vm._u([{key:"actions",fn:function(){return [(!_vm.labelOnly)?_c('base-toggle',{class:{
					required: !!_vm.field.required,
				},attrs:{"required":!!_vm.field.required,"value":_vm.value},on:{"input":_vm.onFieldInput}}):_vm._e()]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }